import React from "react";
import Icon from "../Shared/Icon";
import { KAVACH_COLORS } from "./KavachData";

const KavachPointsSource = ({
  sources = [],
  totalPoints = 0,
  loading = false,
  error = null,
  onRetry,
}) => {
  return (
    <div className="kavach-glass" style={styles.wrap}>
      <div style={styles.header}>
        <div style={styles.headerTitleRow}>
          <Icon name="sparkle" size={18} color={KAVACH_COLORS.gold} />
          <span style={styles.headerTitle}>Points Summary</span>
        </div>
        <span style={styles.headerSub}>Breakdown by earning source</span>
      </div>

      <div className="kavach-scroll" style={styles.listArea}>
        {loading && <span style={styles.stateText}>Loading breakdown…</span>}

        {!loading && error && (
          <div style={styles.errorState}>
            <span style={styles.stateText}>Couldn't load this breakdown.</span>
            <button
              className="kavach-pressable"
              style={styles.retryBtn}
              onClick={onRetry}>
              Retry
            </button>
          </div>
        )}

        {!loading && !error && sources.length === 0 && (
          <span style={styles.stateText}>No points earned yet.</span>
        )}

        {!loading &&
          !error &&
          sources.map((s) => {
            const pct = totalPoints
              ? Math.round((s.points / totalPoints) * 100)
              : 0;
            return (
              <div
                key={s.id}
                style={styles.row}
                className="kavach-pressable kavach-fade-up">
                <div style={styles.rowTop}>
                  <div style={styles.rowLeft}>
                    <div style={styles.iconWrap}>
                      <Icon
                        name={s.icon}
                        size={16}
                        color={KAVACH_COLORS.gold}
                      />
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <span style={styles.label}>{s.label}</span>
                    </div>
                  </div>
                  <span style={styles.points}>
                    {s.points.toLocaleString("en-IN")} pts
                  </span>
                </div>
                <div style={styles.barTrack}>
                  <div style={{ ...styles.barFill, width: `${pct}%` }} />
                </div>
              </div>
            );
          })}
      </div>

      <div style={styles.totalRow}>
        <span style={styles.totalLabel}>Total Points Earned</span>
        <span style={styles.totalValue}>
          {totalPoints.toLocaleString("en-IN")}
        </span>
      </div>
    </div>
  );
};

const styles = {
  wrap: {
    borderRadius: 20,
    width: 360,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    boxShadow: "0 16px 40px rgba(10,20,35,0.28)",
  },
  header: {
    padding: "20px 18px 16px",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
  },
  headerTitleRow: { display: "flex", alignItems: "center", gap: 8 },
  headerTitle: { fontSize: 15, fontWeight: 600, color: "#FFFFFF" },
  headerSub: {
    fontSize: 11.5,
    color: "#9AA6BC",
    marginTop: 6,
    display: "block",
  },
  listArea: {
    flex: 1,
    overflowY: "auto",
    padding: "14px 16px",
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  row: {},
  rowTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  rowLeft: { display: "flex", alignItems: "center", gap: 10, minWidth: 0 },
  iconWrap: {
    width: 30,
    height: 30,
    minWidth: 30,
    borderRadius: 9,
    background: "rgba(255,215,0,0.14)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  label: {
    display: "block",
    fontSize: 12.5,
    fontWeight: 600,
    color: "#DCE3F0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  points: {
    fontSize: 12.5,
    fontWeight: 700,
    color: "#FFFFFF",
    whiteSpace: "nowrap",
  },
  stateText: { fontSize: 12.5, color: "#9AA6BC" },
  errorState: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    alignItems: "flex-start",
  },
  retryBtn: {
    border: "none",
    borderRadius: 10,
    padding: "8px 16px",
    background: KAVACH_COLORS.purple,
    color: "#FFFFFF",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  },
  barTrack: {
    height: 7,
    borderRadius: 7,
    background: "rgba(255,255,255,0.1)",
    overflow: "hidden",
  },
  barFill: {
    height: "100%",
    borderRadius: 7,
    background: `linear-gradient(90deg, ${KAVACH_COLORS.purple}, ${KAVACH_COLORS.gold})`,
    transition: "width 900ms cubic-bezier(.22,1,.36,1)",
  },
  totalRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 18px",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    background: "rgba(255,255,255,0.03)",
  },
  totalLabel: { fontSize: 12.5, fontWeight: 600, color: "#A9B4C9" },
  totalValue: { fontSize: 17, fontWeight: 700, color: KAVACH_COLORS.gold },
};

export default KavachPointsSource;
